<script>
import * as moment from 'moment'
import EggMobileChooser from '@/layerAdmin/components/EggMobileChooser.vue';

export default {
  components: {
    EggMobileChooser,
  },

  data: () => ({
    year: moment().format('YYYY'),
    letter: '',
    placedDate: moment().format('YYYY-MM-DD'),
    placedAge: 0,
    eggMobiles: [],
    typeOfHen: '',
    numberPlaced: 0,
    prePeakKg: 0,
    totalPrePeakCostRand: 0,

    lastAddedBatch: undefined,
  }),

  computed: {
    validationError() {
      if (!this.letter) return 'Please choose a Batch Letter';
      if (!this.placedDate) return 'Please choose a Placed Date';
      if (isNaN(this.placedAge) || Number(this.placedAge) === 0) return 'Please enter the Age (in days)';
      if (!this.eggMobiles || this.eggMobiles.length === 0) return 'Please select at least one Egg Mobile';
      if (!this.typeOfHen || this.typeOfHen.trim().length === 0) return 'Please enter a Type of Hen';
      if (isNaN(this.numberPlaced) || Number(this.numberPlaced) === 0) return 'Please enter the Number of Chicks Placed';
      if (isNaN(this.prePeakKg) || Number(this.prePeakKg) === 0) return 'Please enter the Number of Pre-Peak kg';
      if (isNaN(this.totalPrePeakCostRand) || Number(this.totalPrePeakCostRand) === 0) return 'Please enter the total Pre-Peak cost';

      return undefined;
    },

    submitPayload() {
      return {
        name: this.letterAndYear,
        placed_date: this.placedDate,
        placed_age: this.placedAge,
        egg_mobiles: this.eggMobiles,
        type_of_hen: this.typeOfHen,
        number_placed: this.numberPlaced,
        pre_peak_kg: this.prePeakKg,
        total_pre_peak_cost_rand: this.totalPrePeakCostRand,
      };
    },

    letterAndYear() { return `${this.letter}-${this.year}` },
  },

  methods: {
    clearForm() {
      this.year = moment().format('YYYY');
      this.letter = '';
      this.placedDate = moment().format('YYYY-MM-DD');
      this.placedAge = 0;
      this.eggMobiles = [];
      this.typeOfHen = '';
      this.numberPlaced = 0;
      this.prePeakKg = 0;
      this.totalPrePeakCostRand = 0;
    },

    onFormSubmitSuccess(batch) {
      this.lastAddedBatch = batch;

      this.clearForm();
    },

    onCancelledForm() {
      this.$router.push({ name: 'form-cancelled' });
    },
  },
}
</script>

<template>

  <b-card>
    <api-form
      method="post"
      url="v1/layeradmin/batches"
      :payload="submitPayload"
      :submit-text="lastAddedBatch ? 'Add another' : 'Add'"
      :validation-error="validationError"
      :make-success-message="(batch) => `Batch ${batch.name} successfully added.`"
      @success="onFormSubmitSuccess"
      @cancel="onCancelledForm">

      <slot name="above-header"></slot>

      <h4 class="text-center mt-0">Add Batch</h4>

      <b-form-group label="Batch Letter" :label-for="`letter-${_uid}`">
        <b-input-group>
          <b-form-input :id="`letter-${_uid}`" v-model="letter" type="text" placeholder="Batch letter..." required></b-form-input>
          <b-input-group-text slot="append"> -{{year}} </b-input-group-text>
        </b-input-group>
      </b-form-group>

      <div v-if="letter">
        <b-form-group label="Placed Date" :label-for="`placed-date-${_uid}`">
          <b-form-input :id="`placed-date-${_uid}`" v-model="placedDate" type="date" placeholder="Placed Date..." required></b-form-input>
        </b-form-group>

        <b-form-group label="Age (in days)" :label-for="`age-${_uid}`">
          <b-form-input :id="`age-${_uid}`" v-model="placedAge" type="number" min="1" required @focus="$event.target.select()"></b-form-input>
        </b-form-group>

        <egg-mobile-chooser v-model="eggMobiles" multiple required />

        <b-form-group label="Type of Hen" :label-for="`type-of-hen-${_uid}`">
          <b-form-input :id="`type-of-hen-${_uid}`" v-model="typeOfHen" type="text" required @focus="$event.target.select()"></b-form-input>
        </b-form-group>

        <b-form-group label="Number of Chicks Placed" :label-for="`number-date-${_uid}`">
          <b-form-input :id="`number-date-${_uid}`" v-model="numberPlaced" type="number" min="1" required @focus="$event.target.select()"></b-form-input>
        </b-form-group>

        <label class="font-weight-bold" :for="`pre-peak-kg-${_uid}`">Total Pre-Peak amount</label>
        <b-input-group class="mb-3">
          <b-form-input :id="`pre-peak-kg-${_uid}`" v-model="prePeakKg" type="number" min="1" required @focus="$event.target.select()"></b-form-input>
          <b-input-group-text slot="append"> kg </b-input-group-text>
        </b-input-group>

        <label class="font-weight-bold" :for="`cost-pre-peak-${_uid}`">Total Pre-Peak cost</label>
        <b-input-group class="mb-3">
          <b-input-group-text slot="prepend"> R </b-input-group-text>
          <b-form-input :id="`cost-pre-peak-${_uid}`" v-model="totalPrePeakCostRand" type="number" min="1" required @focus="$event.target.select()"></b-form-input>
        </b-input-group>
      </div>

    </api-form>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AddLayerBatch.vue